"use client";
import { useEffect, useState } from "react";

import HeaderMobile from "/global-layout/headerMobile";
import Header from "./header";
import { useAppContext } from "/context/app-context";

function ClientSideHeader() {
  let platform = "mobile-apps";
  let isDeveloperZone = false;
  let device = { isMobile: false };

  try {
    const context = useAppContext();
    platform = context.platform;
    isDeveloperZone = context.isDeveloperZone;
    device = context.device;
  } catch (error) {
    console.warn("ClientSideHeader: AppContext not available, using defaults");
  }

  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    setIsMobileDevice(device.isMobile);
  }, [device]);

  if (isDeveloperZone) {
    return null;
  } else {
    return isMobileDevice ? (
      <HeaderMobile platform={platform} />
    ) : (
      <Header platform={platform} />
    );
  }
}

export default ClientSideHeader;
